/*
* @requires  pdf-websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function Pdf(param) {
        this.context=param.context;
        this.imp=new $m.PdfWebsocket(param,this,null);
        //this.imp.setEventCallback(this,null);
    }

    Pdf.prototype.openPdf=function (param) {
        this.imp.openPdf(param);
    };

    Pdf.prototype.closePdf=function (param) {
        this.imp.closePdf(param);
    };

    Pdf.prototype.getPdfInfo=function (param) {
        this.imp.getPdfInfo(param);
    };

    Pdf.prototype.getPdfPageInfo=function (param) {
        this.imp.getPdfPageInfo(param);
    };

    Pdf.prototype.savePdf=function (param) {
        this.imp.savePdf(param);
    };

    Pdf.prototype.pdfRenderPage=function (param) {
        this.imp.pdfRenderPage(param);
    };

    Pdf.prototype.getPdfOutlines=function (param) {
        this.imp.getPdfOutlines(param);
    };

    $m.Pdf=Pdf;

})(HebcaMiddleware);
